module.exports = __webpack_public_path__ + "img/carousel-3.e082bc17.jpg";